import PropTypes from 'prop-types';
import EquipmentField from './EquipmentField';
import Section from './Section';
import { EQUIPMENT_MAPPING_LABEL, INVENTORY_STATUS_LABEL } from 'utils/constants';

const InventoryDetails = ({ inventoryValue, inventoryName, inventoryStatus, fieldName, searchTerm }) => {
    if (!inventoryValue && !inventoryName) return null;

    return (
        <Section label="INV">
            {inventoryValue && <EquipmentField label={EQUIPMENT_MAPPING_LABEL[fieldName]} value={inventoryValue} searchTerm={searchTerm} />}
            {inventoryStatus && <EquipmentField label="Status" value={INVENTORY_STATUS_LABEL[inventoryStatus]} searchTerm={searchTerm} />}
            {inventoryName && <EquipmentField label="Type" value={inventoryName} searchTerm={searchTerm} />}
        </Section>
    );
};

InventoryDetails.propTypes = {
    unitNumber: PropTypes.string,
    inventoryName: PropTypes.string,
    inventoryStatus: PropTypes.string,
    fieldName: PropTypes.string.isRequired,
    searchTerm: PropTypes.string,
};

export default InventoryDetails;
